import scssVariables from "./variables.module.scss";

export const colors = {
  backgroundColor: scssVariables.backgroundColor,
  footer: scssVariables.footer,
  black: scssVariables.black,
  white: scssVariables.white,
  whiteOpacity: scssVariables.whiteOpacity,
  grayDark: scssVariables.grayDark,
  gray: scssVariables.gray,
  grayLight: scssVariables.grayLight,
  grayLighter: scssVariables.grayLighter,
  azure: scssVariables.azure,
  transparent: scssVariables.transparent,
  labelInput: scssVariables.labelInput,
  labelInputHover: scssVariables.labelInputHover,
  textInput: scssVariables.textInput,
  backgroundInput: scssVariables.backgroundInput,
  activeText: scssVariables.activeText,
  activeDot: scssVariables.activeDot,
};
